import { render, staticRenderFns } from "./Illu3points.vue?vue&type=template&id=98bc9488&"
import script from "./Illu3points.vue?vue&type=script&lang=js&"
export * from "./Illu3points.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports